<template>
  <div id="app" v-tracking class="overflow-auto">
    <RouterView name="Header" />
    <main>
      <RouterView />
    </main>
    <RouterView name="Footer" />
  </div>
  <UiSnackbar
    :is-shown="snackbarIsShown"
    class="z-50"
    v-bind="snackbarIconName ? { iconName: snackbarIconName } : {}"
  >
    {{ snackbarMessage }}
    <template #action>{{ snackbarAction }}</template>
  </UiSnackbar>
</template>

<script lang="ts" setup>
import UiSnackbar from "@dpa-id-components/dpa-shared-components/src/components/UiSnackbar/UiSnackbar.vue";
import { RouterView } from "vue-router";

import useAppSnackbar from "@/compositions/useAppSnackbar.ts";
import { vTracking } from "@/tracking/vTracking.ts";

const {
  isShown: snackbarIsShown,
  message: snackbarMessage,
  action: snackbarAction,
  iconName: snackbarIconName,
} = useAppSnackbar();
</script>
